import MenuCopyingContainer from './MenuCopying.container';
import MenuCopyingComponent from './MenuCopying.component';

// eslint-disable-next-line new-cap -- FIXME
export default MenuCopyingContainer(MenuCopyingComponent);
